import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const track = (type, page, detail) => axios.post('/api/activity/track', { type, page, detail }).catch(() => {});

const screenshotShortcut = (e) => {
  if (e.key === 'PrintScreen') return 'Print Screen key';
  const k = (e.key || '').toLowerCase();
  if (e.metaKey && e.shiftKey && ['3', '4', '5', '#', '$', '%'].includes(k)) return `Mac Cmd+Shift+${k}`;
  if (e.metaKey && e.shiftKey && k === 's') return 'Windows Snipping (Win+Shift+S)';
  return null;
};

export default function ActivityTracker({ canView }) {
  const location = useLocation();

  useEffect(() => {
    if (!canView(location.pathname)) return;
    track('page_view', location.pathname, `Opened ${location.pathname}`);
  }, [location.pathname]);

  useEffect(() => {
    let last = 0;
    const handler = (e) => {
      const how = screenshotShortcut(e);
      if (!how || Date.now() - last < 1500) return;
      last = Date.now();
      track('screenshot', window.location.pathname, `Screenshot shortcut (${how}) on ${window.location.pathname}`);
    };
    window.addEventListener('keyup', handler);
    window.addEventListener('keydown', handler);
    return () => {
      window.removeEventListener('keyup', handler);
      window.removeEventListener('keydown', handler);
    };
  }, []);

  return null;
}
